import { forwardRef } from "react";

import { cn } from "../../utils/cn";

import type { ComponentPropsWithoutRef } from "react";

const base = "m-0 shrink-0 border-none bg-gray-50 dark:bg-gray-800";

interface DividerProps extends Omit<ComponentPropsWithoutRef<"hr">, "orientation"> {
  orientation?: "horizontal" | "vertical";
}

export const Divider = forwardRef<HTMLHRElement, DividerProps>(
  ({ className, orientation = "horizontal", children, ...props }, ref) => {
    const isHorizontal = orientation === "horizontal";
    if (isHorizontal && children) {
      return (
        <div ref={ref} className="flex w-full items-center">
          <div className={cn(base, className, "h-px flex-1")} role="separator" />
          <span className="mx-4 whitespace-nowrap font-medium">{children}</span>
          <div className={cn(base, className, "h-px flex-1")} role="separator" />
        </div>
      );
    }
    return (
      <hr
        ref={ref}
        className={cn(base, className, isHorizontal ? "h-px w-full" : "h-full w-px")}
        role="separator"
        {...props}
      />
    );
  }
);
Divider.displayName = "Divider";
